<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Basic-Paragraph__And__Centre_Alignment__And__Spacing_After"><span><span class="C_span_char-style-override-10">To all those who seek the truth regarding the assassination of President John F. Kennedy</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?18e7385b